var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSupportIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.464 16.333 1.752 19.25V3.833A.833.833 0 0 1 2.585 3h15a.833.833 0 0 1 .834.833V15.5a.833.833 0 0 1-.834.833zm3.788-4.166v1.666h1.667v-1.666zM7.224 7.844l1.635.328a1.25 1.25 0 1 1 1.226 1.495h-.833v1.666h.833a2.916 2.916 0 1 0-2.86-3.489"
})));
export { SvgSupportIcon as ReactComponent };
export default __webpack_public_path__ + "7e09318f196ebb1d9d6a64b3fcd174a3.svg";